/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminOrderResponse } from '../models/AdminOrderResponse';
import type { OrderCreate } from '../models/OrderCreate';
import type { OrderUpdate } from '../models/OrderUpdate';
import type { OrderView } from '../models/OrderView';
import type { UserOrderResponse } from '../models/UserOrderResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrdersService {
    /**
     * Create Order
     * @param requestBody
     * @returns UserOrderResponse Successful Response
     * @throws ApiError
     */
    public static createOrderOrdersPost(
        requestBody: OrderCreate,
    ): CancelablePromise<UserOrderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/orders/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List My Orders
     * @returns UserOrderResponse Successful Response
     * @throws ApiError
     */
    public static listMyOrdersOrdersOrdersGet(): CancelablePromise<Array<UserOrderResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/orders',
        });
    }
    /**
     * List Orders
     * @returns AdminOrderResponse Successful Response
     * @throws ApiError
     */
    public static listOrdersOrdersAdminOrdersGet(): CancelablePromise<Array<AdminOrderResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/admin/orders',
        });
    }
    /**
     * Update Order
     * @param id
     * @param requestBody
     * @returns UserOrderResponse Successful Response
     * @throws ApiError
     */
    public static updateOrderOrdersAdminIdPut(
        id: number,
        requestBody: OrderUpdate,
    ): CancelablePromise<UserOrderResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/orders/admin/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin Get Order By Id
     * @param id
     * @returns AdminOrderResponse Successful Response
     * @throws ApiError
     */
    public static adminGetOrderByIdOrdersAdminIdGet(
        id: number,
    ): CancelablePromise<AdminOrderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/admin/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Order Invoice View
     * @param orderId
     * @returns OrderView Successful Response
     * @throws ApiError
     */
    public static getOrderInvoiceViewOrdersTaxinvoiceOrderIdGet(
        orderId: number,
    ): CancelablePromise<OrderView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/taxinvoice/{order_id}',
            path: {
                'order_id': orderId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Print Invoice
     * @param orderId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static printInvoiceOrdersTaxinvoicePrintOrderIdGet(
        orderId: number,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/taxinvoice/print/{order_id}',
            path: {
                'order_id': orderId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * User Get Order By Id
     * @param id
     * @returns UserOrderResponse Successful Response
     * @throws ApiError
     */
    public static userGetOrderByIdOrdersIdGet(
        id: number,
    ): CancelablePromise<UserOrderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Order
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteOrderOrdersIdDelete(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/orders/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
